import React from 'react'
import LoadingCandles from '@/shared/ui/LoadingCandles'

type LazySectionProps = {
  children: React.ReactNode
  label?: string
  rootMargin?: string
  forceVisible?: boolean
}

export default function LazySection({
  children,
  label,
  rootMargin = '200px 0px',
  forceVisible = false,
}: LazySectionProps) {
  const [internalVisible, setInternalVisible] = React.useState(false)
  const sentinelRef = React.useRef<HTMLDivElement | null>(null)
  const visible = internalVisible || forceVisible

  React.useEffect(() => {
    if (visible) return
    const el = sentinelRef.current
    if (!el) return

    if (typeof IntersectionObserver === 'undefined') {
      setInternalVisible(true)
      return
    }

    let cancelled = false
    const obs = new IntersectionObserver(
      (entries) => {
        if (cancelled) return
        const entry = entries[0]
        if (entry && entry.isIntersecting) {
          setInternalVisible(true)
        }
      },
      { root: null, rootMargin, threshold: 0 },
    )

    obs.observe(el)

    return () => {
      cancelled = true
      obs.disconnect()
    }
  }, [visible, rootMargin])

  if (visible) {
    return <>{children}</>
  }

  return (
    <div ref={sentinelRef} className="flex w-full items-center justify-center py-10">
      <LoadingCandles className="min-h-[140px]" label={label || 'Carregando seÃ§Ã£o...'} />
    </div>
  )
}

